module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-checkbox', {
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "change": _vm.updateValue
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a828f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Boolean.vue
// module id = 537
// module chunks = 1